import { FieldType, Lang } from '../type';
function base64ToUtf8(base64Str) {
    return new TextDecoder().decode(Uint8Array.from(atob(base64Str), c => c.charCodeAt(0)));
}
function matchFile(data) {
    return typeof data?.content === 'string';
}
export const schema = {
    id: 'ai-page',
    name: 'AI页面',
    pickFields: ['pageConfig'],
    identityField: ['name', 'path'],
    getIdentity: (name, path) => `【${name}（${path}）】`,
    fields: {
        pageConfig: {
            name: '页面配置',
            uncheckable: true,
            unselectable: true,
            details: {
                fsStore: {
                    name: '文件',
                    uncheckable: true,
                    unselectable: true,
                    details: {
                        data: {
                            name: '源代码',
                            uncheckable: true,
                            unselectable: true,
                            details: {
                                src: {
                                    name: 'src',
                                    type: FieldType.TreeObject,
                                    uncheckable: true,
                                    lang: (_, { originData, compareData }) => {
                                        if (matchFile(originData) || matchFile(compareData))
                                            return Lang.Html;
                                        return Lang.Json;
                                    },
                                    format: (origin) => {
                                        if (matchFile(origin))
                                            return base64ToUtf8(origin.content);
                                        return origin;
                                    },
                                },
                            },
                        },
                    },
                },
                collectionRefs: {
                    name: '数据源',
                    type: FieldType.Array,
                    identityField: 'collectionId',
                    idField: 'collectionId',
                    getIdentity: collectionId => `数据源（${collectionId}）`,
                    uncheckable: true,
                },
            },
        },
    },
};
